<template>
  <div class="conversion vh100">
    <!--优惠券模块-->
    <ConversionCoupon v-if="coupon" :couponInfo="coupon" :useEnd="coupon.useEnd"></ConversionCoupon>
    <!--畅学卡模块-->
    <ConversionPrivilege
      :price="price"
      :discountPrice="discountPrice"></ConversionPrivilege>
    <!--知识合伙人模块-->
    <ConversionPoster></ConversionPoster>
  </div>
</template>

<script>
import keys from 'lodash.keys'
import module from '../modules/conversion'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

import ConversionCoupon from '../components/Conversion/ConversionCoupon'
import ConversionPrivilege from '../components/Conversion/ConversionPrivilege'
import ConversionPoster from '../components/Conversion/ConversionPoster'

export default {
  computed: {
    ...mapState(module.name, keys(module.state)),
    ...mapGetters(module.name, keys(module.getters))
  },
  methods: {
    ...mapMutations(module.name, keys(module.mutations)),
    ...mapActions(module.name, keys(module.actions))
  },
  beforeCreate () {
    this.$store.registerModule(module.name, module)
  },
  created () {
    this.init()
  },
  beforeDestroy () {
    this.$store.unregisterModule(module.name)
  },
  components: {
    ConversionCoupon,
    ConversionPrivilege,
    ConversionPoster
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../style/main";

.conversion {
  width: 100%;
  /*min-height: 100vh;*/
  background-image: url("../assets/images/conversion-bg.png");
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
